import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

import firebase from 'firebase'


var firebaseConfig = {
  apiKey: "AIzaSyBVmj6i9qA7AFOfeY3_lDjKW84uXZLswc8",
  authDomain: "service-legends-6ee57.firebaseapp.com",
  databaseURL: "https://service-legends-6ee57.firebaseio.com",
  projectId: "service-legends-6ee57",
  storageBucket: "service-legends-6ee57.appspot.com",
  messagingSenderId: "637258288071",
  appId: "1:637258288071:web:245c260a0d810aff8aa7e2",
  measurementId: "G-LBTE0G1J96"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();




new Vue({
  firebase,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')